import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useUnitDetailsStyles = makeStyles()(theme => ({
  container: {
    background: theme.palette.components.grid.content.backgroundColor,
    border: `1px solid ${theme.palette.system.lightGrey}`,
    borderRadius: '4px',
    opacity: 1,
    position: 'relative',
  },
  header: {
    height: '48px',
    background: theme.palette.system.skyBlue,
    borderBottom: `1px solid ${theme.palette.system.lightGrey}`,
    opacity: 1,
    alignItems: 'center',
  },
  titleSubSection: {
    paddingLeft: '12px',
  },
  removeButton: {
    display: 'block',
    position: 'absolute',
    right: '12px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  titleStyles: {
    color: theme.palette.components.typography.color,
    fontWeight: '500',
    fontSize: '16px !important',
  },
}));

const OrderSubsectionCard = ({ icon, addIcon, title, children }: { icon; title: string; children; addIcon? }) => {
  const { classes } = useUnitDetailsStyles();

  return (
    <Grid container item direction="column" className={classes.container} data-testId="unit-details-card">
      <Grid container item className={classes.header}>
        <Grid item className={classes.titleSubSection}>
          <Box component="span" sx={theme => ({ color: theme.palette.components.box.titleBar.color })}>
            {icon}
          </Box>
        </Grid>
        <Grid item className={classes.titleSubSection}>
          <Typography className={classes.titleStyles}>{title}</Typography>
        </Grid>
        <Grid className={classes.removeButton}>
          <Box component="span" sx={theme => ({ color: theme.palette.components.box.titleBar.color })}>
            {addIcon}
          </Box>
        </Grid>
      </Grid>
      <Grid container item p={2}>
        {children}
      </Grid>
    </Grid>
  );
};

export default OrderSubsectionCard;
